/* Pipli PDP: gallery, zoom, variants, sticky bar, AJAX add-to-cart.
   Extracted from sections/pipli-product-main.liquid so it caches across product views. */
(function () {
  function initPPD(root) {
    if (!root || root.dataset.ppdInit) return;
    root.dataset.ppdInit = '1';
    document.body.classList.add('ppp-pdp');

    // Gallery
    var imgs = root.querySelectorAll('.ppd__img');
    var counter = root.querySelector('[data-ppd-count]');
    var cur = 0;
    // data-i equals the media's true position (so variant nav can target it) and is NOT
    // contiguous once a late-positioned video is appended — walk this order for prev/next.
    var order = Array.prototype.map.call(imgs, function (im) { return im.dataset.i; });
    function posOf(i) { var k = order.indexOf(String(i)); return k < 0 ? 0 : k; }
    // Slides after the first ship with data-src/data-srcset (see the section); hydrate a slide
    // when it becomes active and pre-hydrate its prev/next neighbours so arrows feel instant.
    function hydrate(im) {
      if (!im || im.tagName !== 'IMG' || !im.dataset.src) return;
      if (im.dataset.srcset) { im.srcset = im.dataset.srcset; }
      im.src = im.dataset.src;
      delete im.dataset.src; delete im.dataset.srcset;
    }
    function hydrateAround(i) {
      var k = posOf(i), n = order.length;
      [k, (k + 1) % n, (k - 1 + n) % n].forEach(function (p) { hydrate(imgs[p]); });
    }
    function show(i) {
      cur = Number(i);
      hydrateAround(cur);
      // Restore any slide/thumb temporarily swapped to a variant image (gallery stays canonical)
      root.querySelectorAll('.ppd__img[data-orig], .ppd__thumb img[data-orig]').forEach(function (im) { im.src = im.dataset.orig; if (im.dataset.origset != null) { im.srcset = im.dataset.origset; delete im.dataset.origset; } delete im.dataset.orig; });
      imgs.forEach(function (im) {
        var active = im.dataset.i === String(i);
        im.classList.toggle('is-active', active);
        if (im.tagName === 'VIDEO') {
          if (active) {
            if (!im.src && im.dataset.ppdVsrc) { im.src = im.dataset.ppdVsrc; }
            var pp = im.play(); if (pp && pp.catch) { pp.catch(function () {}); }
          } else { try { im.pause(); } catch (e) {} }
        }
      });
      root.querySelectorAll('.ppd__thumb').forEach(function (t) { t.classList.toggle('is-active', t.dataset.i === String(i)); });
      if (counter) counter.textContent = (posOf(cur) + 1) + ' / ' + imgs.length;
      var th = root.querySelector('.ppd__thumb.is-active');
      if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    root.querySelectorAll('.ppd__thumb').forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.i); }); });
    // Warm the two neighbours of the first slide once the page has settled (after LCP).
    (function () {
      var warm = function () { hydrateAround(cur); };
      var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1200); };
      if (document.readyState === 'complete') { idle(warm); } else { window.addEventListener('load', function () { idle(warm); }); }
    })();
    // If the first slide is a video, start it (muted autoplay) once the page settles.
    (function () {
      var first = root.querySelector('.ppd__img.is-active');
      if (first && first.tagName === 'VIDEO') {
        if (!first.src && first.dataset.ppdVsrc) { first.src = first.dataset.ppdVsrc; }
        var kick = function () { var p = first.play(); if (p && p.catch) { p.catch(function () {}); } };
        if (document.readyState === 'complete') { kick(); } else { window.addEventListener('load', kick); }
      }
    })();

    // Prev / next arrows
    root.querySelectorAll('[data-ppd-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        show(order[(posOf(cur) + Number(b.dataset.ppdNav) + order.length) % order.length]);
      });
    });

    // Tap-to-zoom lightbox
    var stageEl = root.querySelector('.ppd__stage');
    if (stageEl && imgs.length) {
      var zoom = document.createElement('div');
      zoom.className = 'ppd-zoom';
      zoom.hidden = true;
      zoom.innerHTML = '<button type="button" class="ppd-zoom__close" aria-label="Close">&times;</button><div class="ppd-zoom__scroll"><img class="ppd-zoom__img" alt=""></div>';
      document.body.appendChild(zoom);
      var zoomImg = zoom.querySelector('.ppd-zoom__img');
      zoomImg.alt = imgs[0].alt || '';
      function closeZoom() { zoom.hidden = true; document.documentElement.style.overflow = ''; }
      stageEl.addEventListener('click', function (e) {
        if (e.target.closest('.ppd__nav') || e.target.closest('.ppd__count')) return;
        var act = root.querySelector('.ppd__img.is-active');
        if (!act || act.tagName === 'VIDEO' || !act.src) return;
        zoomImg.src = act.src.replace(/width=1000/, 'width=1800');
        zoom.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var sc = zoom.querySelector('.ppd-zoom__scroll');
        requestAnimationFrame(function () { sc.scrollLeft = (sc.scrollWidth - sc.clientWidth) / 2; });
      });
      zoom.addEventListener('click', function (e) { if (!e.target.closest('.ppd-zoom__img')) closeZoom(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zoom.hidden) closeZoom(); });
    }

    // Swipe gallery on touch
    var stage = root.querySelector('.ppd__stage');
    if (stage && imgs.length > 1) {
      var sx = 0, sy = 0;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        show(order[(posOf(cur) + (dx < 0 ? 1 : order.length - 1)) % order.length]);
      }, { passive: true });
    }

    // Estimated delivery window (production 3–5 days + transit ≈ 5–9 days out)
    var etaBox = root.querySelector('[data-ppd-delivery]');
    if (etaBox) {
      var etaEl = etaBox.querySelector('[data-ppd-eta]');
      var fmt = function (d) { return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); };
      var a = new Date(); a.setDate(a.getDate() + 5);
      var b = new Date(); b.setDate(b.getDate() + 9);
      if (etaEl) { etaEl.textContent = fmt(a) + ' – ' + fmt(b); etaBox.hidden = false; }
    }

    // Rating → scroll to reviews widget
    var rateBtn = root.querySelector('[data-ppd-reviews]');
    if (rateBtn) {
      rateBtn.addEventListener('click', function () {
        var w = document.querySelector('.jdgm-rev-widg, .jdgm-widget, [id^="judgeme"], [data-review-widget]');
        if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Quantity
    root.querySelectorAll('[data-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var inp = root.querySelector('[data-ppd-qty]'); var v = (parseInt(inp.value, 10) || 1) + (btn.getAttribute('data-q') === '+' ? 1 : -1); inp.value = Math.max(1, v);
      });
    });

    // Variants
    var variants = []; var prices = {};
    try { variants = JSON.parse(root.querySelector('[data-ppd-variants]').textContent); } catch (e) {}
    try { prices = JSON.parse(root.querySelector('[data-ppd-prices]').textContent); } catch (e) {}
    var idInput = root.querySelector('[data-ppd-id]');
    var addBtn = root.querySelector('[data-ppd-add]');
    var addLabelEl = root.querySelector('[data-ppd-add-label]');
    var priceNow = root.querySelector('[data-price-now]');
    // Sticky mobile add-to-cart bar (mirrors the main buy box)
    var mAdd = root.querySelector('[data-ppd-madd]');
    var mAddLabel = root.querySelector('[data-ppd-madd-label]');
    var mPrice = root.querySelector('[data-ppd-mprice]');
    var ppdForm = root.querySelector('.ppd__form');
    var isPerso = !!root.querySelector('[data-ppd-perso]');
    // Collect line-item properties (e.g. personalized name) from the product form.
    function ppdCollectProps() {
      if (!ppdForm) return null;
      var props = {}, has = false;
      ppdForm.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        var m = el.name.match(/^properties\[(.+)\]$/); if (!m) return;
        props[m[1]] = el.value; has = true;
      });
      return has ? props : null;
    }
    // Block add-to-cart if a required personalization field is empty.
    function ppdValidatePerso() {
      if (!ppdForm) return true;
      var bad = null;
      ppdForm.querySelectorAll('[data-ppd-perso][required]').forEach(function (el) {
        if (!bad && !el.value.trim()) bad = el;
      });
      if (bad) {
        bad.classList.add('is-error');
        try { bad.focus({ preventScroll: true }); } catch (e) {}
        bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        toast('Please enter the name to personalize', true);
        return false;
      }
      return true;
    }
    root.querySelectorAll('[data-ppd-perso]').forEach(function (el) {
      el.addEventListener('input', function () { el.classList.remove('is-error'); });
    });
    // Sticky bar fires GoKwik Buy Now (express checkout); falls back to add-to-cart if GoKwik isn't present
    if (mAdd) { mAdd.addEventListener('click', function () {
      if (!ppdValidatePerso()) return;
      var gk = document.getElementById('gokwik-buy-now');
      if (gk && !gk.disabled) { gk.click(); return; }
      if (!addBtn.disabled) addBtn.click();
    }); }

    // Personalized products: GoKwik's Buy Now (onclick=onBuyNowClick, injected by the app) is a black box we
    // can't trust to carry the custom-name line-item property. Intercept it and run a cart-based express flow:
    // add-to-cart WITH the property, then open GoKwik express on the cart so the name always reaches the order.
    function ppdFireGokwikCheckout() {
      var n = 0;
      (function go() {
        var b = document.querySelector('cart-drawer .gokwik-checkout button:not([disabled]), .gokwik-checkout button:not([disabled])');
        if (b) { b.click(); return; }
        if (++n <= 20) { setTimeout(go, 200); }
        else { window.location.href = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'); }
      })();
    }
    function ppdExpressBuyNow() {
      if (!ppdValidatePerso()) return;
      var qty = Math.max(1, parseInt(root.querySelector('[data-ppd-qty]').value, 10) || 1);
      var item = { id: Number(idInput.value), quantity: qty };
      var props = ppdCollectProps(); if (props) item.properties = props;
      var body = { items: [item] };
      var drawer = document.querySelector('cart-drawer');
      if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
      setAddDisabled(true); setAddLabel('Adding…');
      var u = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add');
          if (drawer && res.d.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res.d); }
          ppdFireGokwikCheckout();
          setTimeout(function () { setAddDisabled(false); setAddLabel('Add to cart'); }, 1600);
        })
        .catch(function (err) { setAddDisabled(false); setAddLabel('Add to cart'); toast(err.message || 'Could not add to cart', true); });
    }
    if (isPerso) {
      var gkBuy = document.getElementById('gokwik-buy-now');
      if (gkBuy) {
        // Capture phase + stopImmediatePropagation beats the inline onclick handler.
        gkBuy.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); ppdExpressBuyNow(); }, true);
      }
    }

    // Sticky bar is visible whenever neither Add-to-cart nor Buy It Now is on screen
    // (below the fold on landing, or scrolled past) and hides while either is in view.
    var mBar = root.querySelector('[data-ppd-mbar]');
    var mImg = root.querySelector('[data-ppd-mimg]');
    var buyRow = root.querySelector('.ppd__buy');
    var gkBtn = document.getElementById('gokwik-buy-now');
    if (mBar && buyRow && 'IntersectionObserver' in window) {
      var ctaVis = { buy: false, gk: false };
      var updBar = function () { mBar.classList.toggle('is-visible', !(ctaVis.buy || ctaVis.gk)); };
      new IntersectionObserver(function (en) { ctaVis.buy = en[0].isIntersecting; updBar(); }, { threshold: 0 }).observe(buyRow);
      if (gkBtn) {
        new IntersectionObserver(function (en) { ctaVis.gk = en[0].isIntersecting; updBar(); }, { threshold: 0 }).observe(gkBtn);
      }
    } else if (mBar) {
      mBar.classList.add('is-visible');
    }
    function setAddLabel(txt) { if (addLabelEl) { addLabelEl.textContent = txt; } else { addBtn.textContent = txt; } }
    function setAddDisabled(d) { addBtn.disabled = d; if (mAdd) mAdd.disabled = d; }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('.ppd__opt').forEach(function (o) {
        var checked = o.querySelector('input:checked'); if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function match() {
      var sel = selectedOptions(); if (!sel.length) return null;
      return variants.find(function (v) { return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    root.querySelectorAll('.ppd__pill input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        root.querySelectorAll('.ppd__pill').forEach(function (p) { p.classList.toggle('is-checked', p.contains(p.querySelector('input:checked'))); });
        var v = match(); if (!v) return;
        idInput.value = v.id;
        var meta = prices[v.id];
        if (meta) {
          if (priceNow) priceNow.textContent = meta.f;
          if (mPrice) mPrice.textContent = meta.f;
          setAddDisabled(!meta.a); setAddLabel(meta.a ? 'Add to cart' : 'Sold out');
          if (mAddLabel) { mAddLabel.textContent = meta.a ? 'Buy Now' : 'Sold out'; }
          if (meta.mi != null && root.querySelector('.ppd__img[data-i="' + meta.mi + '"]')) { show(meta.mi); }
          else if (meta.img) {
            // Variant image isn't one of the (max 20) gallery slides — swap it in on the active slide, remembering the original
            var t = root.querySelector('.ppd__img.is-active');
            if (t) { if (!t.dataset.orig) { t.dataset.orig = t.src; t.dataset.origset = t.srcset || ''; } t.src = meta.img; t.srcset = meta.img; }
            var th = root.querySelector('.ppd__thumb.is-active img');
            if (th) { if (!th.dataset.orig) { th.dataset.orig = th.src; } th.src = meta.tim || meta.img; }
          }
          if (meta.img && mImg) { mImg.src = meta.tim || meta.img; }
        }
      });
    });

    // AJAX add (progressive enhancement; native submit is the fallback)
    var form = root.querySelector('.ppd__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!ppdValidatePerso()) { e.preventDefault(); return; }
        if (!window.fetch) return; // let it submit normally
        e.preventDefault();
        var qty = Math.max(1, parseInt(root.querySelector('[data-ppd-qty]').value, 10) || 1);
        var id = idInput.value; var label = addLabelEl ? addLabelEl.textContent : addBtn.textContent;
        setAddDisabled(true); setAddLabel('Adding…');
        var ppdDrawer = document.querySelector('cart-drawer');
        var ppdItem = { id: Number(id), quantity: qty };
        var ppdProps = ppdCollectProps();
        if (ppdProps) ppdItem.properties = ppdProps;
        var ppdBody = { items: [ppdItem] };
        if (ppdDrawer) { ppdBody.sections = ['cart-drawer', 'cart-icon-bubble']; ppdBody.sections_url = window.location.pathname; }
        var u = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
        fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(ppdBody) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Could not add');
            setAddLabel('Added ✓');
            if (ppdDrawer && res.d.sections && typeof ppdDrawer.renderContents === 'function') { ppdDrawer.renderContents(res.d); }
            else { toast('Added to cart'); var cu = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js'; fetch(cu).then(function (r) { return r.json(); }).then(function (c) { document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function (s) { s.textContent = c.item_count; }); document.querySelectorAll('.cart-count-bubble').forEach(function (bb) { bb.style.removeProperty('display'); }); }).catch(function () {}); }
            setTimeout(function () { setAddLabel(label); setAddDisabled(false); }, 1700);
          })
          .catch(function (err) {
            // Fallback to native Shopify form submit so add-to-cart always works
            try { form.submit(); } catch (e2) { setAddLabel(label); setAddDisabled(false); toast(err.message || 'Could not add to cart', true); }
          });
      });
    }
    function toast(msg, err) {
      var t = document.createElement('div'); t.className = 'ppf-toast' + (err ? ' ppf-toast--err' : ''); t.textContent = msg;
      document.body.appendChild(t); requestAnimationFrame(function () { t.classList.add('show'); });
      setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 2200);
    }
  }

  document.querySelectorAll('section.ppd').forEach(initPPD);
})();
